import { useLocaleContext } from '@src/components/locale/locale.context'
import { ECOUNTRIES } from '@src/config/localisation/locale-config.constants'
import { STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'
import { parseLocale } from '@src/utils/i18n.utils'

export default function usePDPModelSizeTagExperiment(): boolean {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.PDP_MODEL_SIZE_TAG_VISIBILITY)
  const { locale } = useLocaleContext()
  const country = parseLocale(locale).country
  const showModelSizeTag = country === ECOUNTRIES.us && experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.SHOW
  return showModelSizeTag
}
